import { isEmbedMode } from 'v2/shared/utils/embed-session'

/** What the Queue & Route sidebar shows per mode. Pure, so the embed forks are testable. */
export interface QnrView {
  // Org members are not on the embed gateway (useUsersQuery is off in embed).
  includeOrgMembers: boolean
  // Flow variables still route through the 'agents' tab in embed, so it is relabelled.
  humansTabLabel: 'Agents' | 'Variables'
  // "Create new" opens /queues in a new tab, which has no embed route or session.
  showCreateQueue: boolean
  // Core's embed proxy refuses a save that adds the node, so the palette never offers it.
  inPalette: boolean
}

export const qnrViewFor = (embed: boolean): QnrView => ({
  includeOrgMembers: !embed,
  humansTabLabel: embed ? 'Variables' : 'Agents',
  showCreateQueue: !embed,
  inPalette: !embed,
})

export const qnrView = (): QnrView => qnrViewFor(isEmbedMode())
